import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { deleteMovies, getMovieById } from "../store/actions/moviesActions";
import Swal from 'sweetalert2'

export default function MovieList(props) {
  const dispatch = useDispatch()

  const handleDelete = (event, id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteMovies(id))
        Swal.fire(
          'Deleted!',
          'Your file has been deleted.',
          'success'
        )
        window.location.reload()
      }
    })
  }

  const convertToRupiah = (angka) => {
    let rupiah = '';		
    let angkarev = angka.toString().split('').reverse().join('');
    for(let i = 0; i < angkarev.length; i++) if(i%3 == 0) rupiah += angkarev.substr(i,3)+'.';
    return 'Rp. '+rupiah.split('',rupiah.length-1).reverse().join('');
  }

  return (
    <>
    {props.loading ? 
      <h3>Loading Page</h3> :
      <div className="container">
        <br/>
        <h3>Movie List</h3>
        <table id="mytable" className="table table-bordred table-striped">
          <thead>
            <tr>
              <th>Id</th>
              <th>Title</th>
              <th>Synopsis</th>
              <th>Poster</th>
              <th>Rating</th>
              <th>Genre</th>
              <th>Price</th>
              <th>Quantity</th>
              <th>Edit</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {props.movies.map(movie => {
              return (
                <tr key={movie.id}>
                  <td>{movie.id}</td>
                  <td>{movie.title}</td>
                  <td>{movie.synopsis}</td>
                  <td>
                    <img src={movie.imgUrl} className="img-fluid rounded-start"/>
                  </td>
                  <td>{movie.rating}</td>
                  <td>{movie.Genre.name}</td>
                  <td>{convertToRupiah(movie.price)}</td>
                  <td>{movie.quantity}</td>
                  <td>
                    <Link to={{
                      pathname: `/movie/${movie.id}`,
                      state: {id: movie.id, UpdateMovie: true}
                    }}>
                    <button className="btn btn-outline-primary" data-title="Edit" data-toggle="modal" data-target="#edit">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fillRule="evenodd" d="M17.263 2.177a1.75 1.75 0 012.474 0l2.586 2.586a1.75 1.75 0 010 2.474L19.53 10.03l-.012.013L8.69 20.378a1.75 1.75 0 01-.699.409l-5.523 1.68a.75.75 0 01-.935-.935l1.673-5.5a1.75 1.75 0 01.466-.756L14.476 4.963l2.787-2.786zm-2.275 4.371l-10.28 9.813a.25.25 0 00-.067.108l-1.264 4.154 4.177-1.271a.25.25 0 00.1-.059l10.273-9.806-2.94-2.939zM19 8.44l2.263-2.262a.25.25 0 000-.354l-2.586-2.586a.25.25 0 00-.354 0L16.061 5.5 19 8.44z"></path></svg>
                    </button>
                    </Link>
                  </td>
                  <td>
                    <button className="btn btn-outline-danger" data-title="Delete" data-toggle="modal" data-target="#delete" onClick={(e) => handleDelete(e, movie.id)}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fillRule="evenodd" d="M16 1.75V3h5.25a.75.75 0 010 1.5H2.75a.75.75 0 010-1.5H8V1.75C8 .784 8.784 0 9.75 0h4.5C15.216 0 16 .784 16 1.75zm-6.5 0a.25.25 0 01.25-.25h4.5a.25.25 0 01.25.25V3h-5V1.75z"></path><path d="M4.997 6.178a.75.75 0 10-1.493.144L4.916 20.92a1.75 1.75 0 001.742 1.58h10.684a1.75 1.75 0 001.742-1.581l1.413-14.597a.75.75 0 00-1.494-.144l-1.412 14.596a.25.25 0 01-.249.226H6.658a.25.25 0 01-.249-.226L4.997 6.178z"></path><path d="M9.206 7.501a.75.75 0 01.793.705l.5 8.5A.75.75 0 119 16.794l-.5-8.5a.75.75 0 01.705-.793zm6.293.793A.75.75 0 1014 8.206l-.5 8.5a.75.75 0 001.498.088l.5-8.5z"></path></svg>
                    </button>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    }
    </>
  )
}